// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfoTour_mainCont__i7Wgn {}

.InfoTour_blockTour__-OlEx {
    display: flex;
    background: linear-gradient(135deg, #0a0f23 0%, #1c2230 100%);

    cursor: pointer;
    border-radius: 10px;

    box-shadow: 0 5px 10px 0 #000;
    transition: all 0.5s ease-in;



}

.InfoTour_blockTour__-OlEx:hover {
    box-shadow: 0 5px 10px 0 #5f2dca;
}

.InfoTour_blockInf__bxQVB .InfoTour_info__DZu3l {
    font-size: 18px;
    color: white;
    font-weight: 700;
    font-family: Arial, Helvetica, sans-serif;
}

.InfoTour_top__4cGyt {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    z-index: 2;

}

.InfoTour_info_prize__CdhzP {
    color: white;
    font-size: 20px;
    font-weight: 900;
    font-family: Muller, sans-serif;
    border-radius: 10px;
    letter-spacing: 0.5px;
}

.InfoTour_containerInformation__wzc5t {
    display: flex;
    width: 40%;
    padding: 10px;
    flex-direction: column;
    border-radius: 10px;
    background: linear-gradient(135deg, #0a0f23 0%, #1c2230 100%);

    justify-content: space-between;

    gap: 10px;
}

.InfoTour_headerSmall__1ymqB {
    color: rgba(255, 255, 255, 0.458);
    font-family: Popins, sans-serif;
    font-size: 15px;
}

.InfoTour_timeReg__2MW6O {
    color: white;
    font-family: Popins, sans-serif;
    font-weight: 700;
    font-size: 20px;
    letter-spacing: 1px;
}

.InfoTour_buttonPlay__--7bR {
    display: flex;

    border-radius: 10px !important;
    margin:10px;
    font-weight: 900;
    font-size: 20px;
    box-shadow: 0px 7px #5f2dca;
    background-color: #773DF3;
    text-transform: uppercase;
    transition: all 0.3s ease-in-out;

}

.InfoTour_header__sFcft {
    font-size: 20px;
    font-weight: 900;
    color: white;

    font-family: monospace , sans-serif;
    text-align: center;

}

.InfoTour_blockInf__bxQVB {
    display: flex;
    flex-direction: column;
    padding-left: 30px;
    gap: 5px;

}

.InfoTour_blocksInf__j8Whj {
    display: flex;
    flex-direction: column;
    border-top: 2px dashed #ffffff6b;
    margin: -10px;
    padding-top: 20px;
    padding-bottom: 20px;
    gap: 10px;
}

.InfoTour_amount__d0Pi1 {
    display: flex;
    flex-direction: column;
    gap:0;

    font-size: 35px;
    font-family: Popins, sans-serif;
    line-height: 46px;
    font-weight: 900;

    color: #fff;
    /* Зеленый цвет */
    
    text-transform: uppercase;
    letter-spacing: 1px;
    background: linear-gradient(45deg, #ff8c00, #ffa500);
    border: none;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 3px 12px rgba(255, 140, 0, 0.7);
    transition: transform 0.3s ease;
    text-align: center;
    
}

.InfoTour_gamecard_window__iDSud {
    border-radius: 5px;
    box-shadow: 0 -2px 20px 0 #0006;
    box-sizing: border-box;
    height: inherit;
    max-width: calc(100% - 300px);
    position: relative;
    width: 100%;
}

.InfoTour_cardImage__qRnHB {}

.InfoTour_gamecard_window__iDSud img {
    height: 100%;

    width: 100%;
    object-fit: cover;
    border-radius: 10px;

}

@media screen and (max-width: 1000px) {

    .InfoTour_blockTour__-OlEx {
        display: flex;
        flex-direction: column;
    }

    .InfoTour_gamecard_window__iDSud {
        max-width: 100%;
    }

    .InfoTour_containerInformation__wzc5t {
        width: 100%;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    .InfoTour_amount__d0Pi1 {
        font-size: 35px;
        padding: 5px;

    }

    .InfoTour_header__sFcft {
        margin-bottom: 20px;
    }

    .InfoTour_top__4cGyt {
        position: absolute;
        top: 10px;
        left: 10px;
    }
}

@media screen and (max-width:800px) {
    .InfoTour_gamecard_window__iDSud img {
        height: 200px;
    }

    .InfoTour_blockTour__-OlEx:hover {
        box-shadow: 0 5px 10px 0 #000;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Tournaments/components/InfoTour/InfoTour.module.css"],"names":[],"mappings":"AAAA,2BAAW;;AAEX;IACI,aAAa;IACb,6DAA6D;;IAE7D,eAAe;IACf,mBAAmB;;IAEnB,6BAA6B;IAC7B,4BAA4B;;;;AAIhC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,UAAU;;AAEd;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6DAA6D;;IAE7D,8BAA8B;;IAE9B,SAAS;AACb;;AAEA;IACI,iCAAiC;IACjC,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;;IAEb,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,yBAAyB;IACzB,yBAAyB;IACzB,gCAAgC;;AAEpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;;IAEZ,mCAAmC;IACnC,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;;AAEZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,KAAK;;IAEL,eAAe;IACf,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;;IAEhB,WAAW;IACX,iBAAiB;;IAEjB,yBAAyB;IACzB,mBAAmB;IACnB,oDAAoD;IACpD,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;IAC7C,+BAA+B;IAC/B,kBAAkB;;AAEtB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,sBAAsB;IACtB,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;AACf;;AAEA,4BAAY;;AAEZ;IACI,YAAY;;IAEZ,WAAW;IACX,iBAAiB;IACjB,mBAAmB;;AAEvB;;AAEA;;IAEI;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,yBAAyB;QACzB,0BAA0B;IAC9B;;IAEA;QACI,eAAe;QACf,YAAY;;IAEhB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,UAAU;IACd;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,6BAA6B;IACjC;AACJ","sourcesContent":[".mainCont {}\n\n.blockTour {\n    display: flex;\n    background: linear-gradient(135deg, #0a0f23 0%, #1c2230 100%);\n\n    cursor: pointer;\n    border-radius: 10px;\n\n    box-shadow: 0 5px 10px 0 #000;\n    transition: all 0.5s ease-in;\n\n\n\n}\n\n.blockTour:hover {\n    box-shadow: 0 5px 10px 0 #5f2dca;\n}\n\n.blockInf .info {\n    font-size: 18px;\n    color: white;\n    font-weight: 700;\n    font-family: Arial, Helvetica, sans-serif;\n}\n\n.top {\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n    z-index: 2;\n\n}\n\n.info_prize {\n    color: white;\n    font-size: 20px;\n    font-weight: 900;\n    font-family: Muller, sans-serif;\n    border-radius: 10px;\n    letter-spacing: 0.5px;\n}\n\n.containerInformation {\n    display: flex;\n    width: 40%;\n    padding: 10px;\n    flex-direction: column;\n    border-radius: 10px;\n    background: linear-gradient(135deg, #0a0f23 0%, #1c2230 100%);\n\n    justify-content: space-between;\n\n    gap: 10px;\n}\n\n.headerSmall {\n    color: rgba(255, 255, 255, 0.458);\n    font-family: Popins, sans-serif;\n    font-size: 15px;\n}\n\n.timeReg {\n    color: white;\n    font-family: Popins, sans-serif;\n    font-weight: 700;\n    font-size: 20px;\n    letter-spacing: 1px;\n}\n\n.buttonPlay {\n    display: flex;\n\n    border-radius: 10px !important;\n    margin:10px;\n    font-weight: 900;\n    font-size: 20px;\n    box-shadow: 0px 7px #5f2dca;\n    background-color: #773DF3;\n    text-transform: uppercase;\n    transition: all 0.3s ease-in-out;\n\n}\n\n.header {\n    font-size: 20px;\n    font-weight: 900;\n    color: white;\n\n    font-family: monospace , sans-serif;\n    text-align: center;\n\n}\n\n.blockInf {\n    display: flex;\n    flex-direction: column;\n    padding-left: 30px;\n    gap: 5px;\n\n}\n\n.blocksInf {\n    display: flex;\n    flex-direction: column;\n    border-top: 2px dashed #ffffff6b;\n    margin: -10px;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    gap: 10px;\n}\n\n.amount {\n    display: flex;\n    flex-direction: column;\n    gap:0;\n\n    font-size: 35px;\n    font-family: Popins, sans-serif;\n    line-height: 46px;\n    font-weight: 900;\n\n    color: #fff;\n    /* Зеленый цвет */\n    \n    text-transform: uppercase;\n    letter-spacing: 1px;\n    background: linear-gradient(45deg, #ff8c00, #ffa500);\n    border: none;\n    border-radius: 10px;\n    overflow: hidden;\n    box-shadow: 0 3px 12px rgba(255, 140, 0, 0.7);\n    transition: transform 0.3s ease;\n    text-align: center;\n    \n}\n\n.gamecard_window {\n    border-radius: 5px;\n    box-shadow: 0 -2px 20px 0 #0006;\n    box-sizing: border-box;\n    height: inherit;\n    max-width: calc(100% - 300px);\n    position: relative;\n    width: 100%;\n}\n\n.cardImage {}\n\n.gamecard_window img {\n    height: 100%;\n\n    width: 100%;\n    object-fit: cover;\n    border-radius: 10px;\n\n}\n\n@media screen and (max-width: 1000px) {\n\n    .blockTour {\n        display: flex;\n        flex-direction: column;\n    }\n\n    .gamecard_window {\n        max-width: 100%;\n    }\n\n    .containerInformation {\n        width: 100%;\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n    }\n\n    .amount {\n        font-size: 35px;\n        padding: 5px;\n\n    }\n\n    .header {\n        margin-bottom: 20px;\n    }\n\n    .top {\n        position: absolute;\n        top: 10px;\n        left: 10px;\n    }\n}\n\n@media screen and (max-width:800px) {\n    .gamecard_window img {\n        height: 200px;\n    }\n\n    .blockTour:hover {\n        box-shadow: 0 5px 10px 0 #000;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainCont": `InfoTour_mainCont__i7Wgn`,
	"blockTour": `InfoTour_blockTour__-OlEx`,
	"blockInf": `InfoTour_blockInf__bxQVB`,
	"info": `InfoTour_info__DZu3l`,
	"top": `InfoTour_top__4cGyt`,
	"info_prize": `InfoTour_info_prize__CdhzP`,
	"containerInformation": `InfoTour_containerInformation__wzc5t`,
	"headerSmall": `InfoTour_headerSmall__1ymqB`,
	"timeReg": `InfoTour_timeReg__2MW6O`,
	"buttonPlay": `InfoTour_buttonPlay__--7bR`,
	"header": `InfoTour_header__sFcft`,
	"blocksInf": `InfoTour_blocksInf__j8Whj`,
	"amount": `InfoTour_amount__d0Pi1`,
	"gamecard_window": `InfoTour_gamecard_window__iDSud`,
	"cardImage": `InfoTour_cardImage__qRnHB`
};
export default ___CSS_LOADER_EXPORT___;
